module.exports = __webpack_public_path__ + "static/media/allRightImg.b633b1e6.jpg";